'use strict';

var ChartDashboardClassFare = function ChartDashboardClassFare(AbstractChart, scalesService, chartGroups, chartSimpleBars, chartXAxis, chartYAxis, chartCircles, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var ONE_BAR_SPACE = 49;
  var EMTY_SPACE_BETWEEN_BARS = 9;
  var EMTY_SPACE_BEFORE_AFTER_CHART = 4.9;
  var Chart = function Chart(container, formatters) {
    //var self = this;
    AbstractChart.call(this, container);
    // chart components
    var groups = chartGroups('xLabel', formatters && formatters.tooltipFormatter, true);
    var bar = chartSimpleBars('barValue');
    var xAxis = chartXAxis();
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withHorizontalLinesValues([0]);
    var circles = chartCircles('circles');
    this.render = function (data) {
      var width = data.length * ONE_BAR_SPACE - EMTY_SPACE_BETWEEN_BARS + EMTY_SPACE_BEFORE_AFTER_CHART;
      this.initChart(data, undefined, chartParams.bind(null, width));
      this.scales = chartScales(this.params, this.data);
      this.callForDataGroup([yAxisLeft, groups, bar, circles, xAxis], this.scales);
    };
    this.yAxisLabel = function (yAxisLabel) {
      yAxisLeft.label(yAxisLabel);
    };
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartDashboardClassFare.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsCircles', 'ChartElementsConstants'];
module.exports = ChartDashboardClassFare;